// getUserMedia() can hang instead of reject on some WebViews — bound it so
// a stuck permission prompt can't freeze router navigation.
const PERMISSION_TIMEOUT_MS = 15000;

export async function requestMicPermission(): Promise<boolean> {
  try {
    // Check if running in Tauri environment
    const isTauri = '__TAURI__' in window;

    if (isTauri) {
      console.log('Running in Tauri - requesting microphone permission');
    }

    // Request microphone access (works for both web and Tauri Android)
    // On Tauri Android, this will trigger the native permission dialog
    const stream = await Promise.race([
      navigator.mediaDevices.getUserMedia({
        audio: {
          sampleRate: 22050,
          channelCount: 1,
        }
      }),
      new Promise<never>((_, reject) =>
        setTimeout(() => reject(new Error('getUserMedia timed out')), PERMISSION_TIMEOUT_MS)
      ),
    ]);

    // Stop the stream immediately after permission is granted
    stream.getTracks().forEach(track => track.stop());

    console.log('Microphone permission granted');
    return true;
  } catch (error) {
    console.error('Microphone permission denied:', error);
    return false;
  }
}

async function checkMicPermission(): Promise<boolean> {
  try {
    if (!navigator.permissions) {
      // Permissions API not available, assume permission needed
      return false;
    }

    const result = await navigator.permissions.query({ name: 'microphone' as PermissionName });
    return result.state === 'granted';
  } catch (error) {
    // Permissions API might not support microphone query
    // Return false to trigger permission request
    return false;
  }
}
